<template>
  <BaseModal
    name="EditsTariffModal"
    width="640"
    :clickToClose="false"
    :shiftY="0.5"
    @before-close="() => {}"
    @before-open="loadData"
    :adaptive="true"
    height="auto"
    classes="tw-app-modal"
  >
    <div class="tw-app-modal__container">
      <BaseLoader
        v-if="localLoading"
        class="tw-rounded-[25px]"
        style="z-index: 1000"
      ></BaseLoader>
      <button
        type="button"
        class="btn-close tw-app-modal__close"
        @click="$modal.hide('EditsTariffModal')"
      ></button>

      <div>
        <div class="tw-app-modal__title">
          {{ dataLang["tariff_register_text_93"] }}
        </div>

        <div class="tw-grid tw-grid-cols-[45%_auto] tw-mb-[6px]">
          <div>
            {{ dataLang["tariff_register_text_12"] }}
          </div>
          <div class="tw-pl-[11px]">
            {{ dataForModal.vehicles__id }}
          </div>
        </div>
        <div class="tw-grid tw-grid-cols-[45%_auto] tw-mb-[6px]">
          <div>
            {{ dataLang["tariff_register_text_13"] }}
          </div>
          <div class="tw-pl-[11px]">
            {{ dataForModal.vehicles__name }}
          </div>
        </div>
        <div class="tw-grid tw-grid-cols-[45%_auto] tw-mb-[6px]">
          <div>
            {{ dataLang["tariff_register_text_15"] }}
          </div>
          <div class="tw-pl-[11px]">
            {{ dataForModal.vehicles__gosnumber }}
          </div>
        </div>
        <div class="tw-grid tw-grid-cols-[45%_auto] tw-mb-[6px]">
          <div>
            {{ dataLang["tariff_register_text_14"] }}
          </div>
          <div class="tw-pl-[11px]">
            {{ dataForModal.vehicles__year_release }}
          </div>
        </div>

        <!-- ssss -->

        <div class="tw-grid tw-grid-cols-[45%_auto] tw-mb-[6px] tw-mt-[15px]">
          <div>
            {{ dataLang["tariff_register_text_94"] }}
          </div>
          <div class="tw-pl-[11px]" v-if="dataForModal.vehicles__cost">
            {{ dataForModal.vehicles__cost.split(".")[0] }}
          </div>
        </div>
        <div class="tw-grid tw-grid-cols-[45%_auto] tw-items-center tw-mb-[6px]">
          <div>
            {{ dataLang["tariff_register_text_95"] }}
          </div>
          <div ref="tariff_for_car__koeff_price">
            <BaseInputNew
              inputClass="tw-app-input-type-3"
              input-name="tariff_for_car__koeff_price"
              @input="updateValue"
              :horizontalTitle="false"
              :value="dataForModal.tariff_for_car__koeff_price"
              maxLength="5"
            />
          </div>
        </div>

        <div class="tw-grid tw-grid-cols-[45%_auto] tw-mb-[6px]">
          <div>
            {{ dataLang["tariff_register_text_96"] }}
          </div>
          <div class="tw-pl-[11px]">
            {{ Math.floor(Number(calcPrice)) }}
          </div>
        </div>

        <div class="tw-grid tw-grid-cols-[45%_auto] tw-items-center tw-mb-[6px]">
          <div>
            {{ dataLang["tariff_register_text_5"] }}
            <span class="tw-text-lightText">
              {{ dataLang["tariff_register_text_106"] }}
            </span>
          </div>
          <div ref="tariff_for_car__pledge">
            <BaseInputNew
              inputClass="tw-app-input-type-3"
              input-name="tariff_for_car__pledge"
              @input="updateValue"
              :horizontalTitle="false"
              :value="dataForModal.tariff_for_car__pledge"
              inputRef="tariff_for_car__pledge"
              inputMask="00000000"
              maxLength="8"
            />
          </div>
        </div>

        <div class="tw-grid tw-grid-cols-[45%_auto] tw-items-center tw-mb-[6px]">
          <div>
            {{ dataLang["tariff_register_text_112"] }}
          </div>
          <div ref="tariff_for_car__group_id">
            <BaseSelect
              class="multiselect-type-3"
              placeholder=""
              style="width: 100%"
              selectLabel=""
              deselectLabel=""
              @input="
                (data) =>
                  updateValue({
                    name: 'tariff_for_car__group_id',
                    value: data.tariff_groups_for_car__id,
                  })
              "
              v-model="selectsFromModal.grkoef"
              :options="selectsData.grkoef"
              label="tariff_groups_for_car__name"
            >
              <template slot="noOptions">{{
                dataLang["select_empty"]
              }}</template>
              <template slot="noResult">{{
                dataLang["select_search_empty"]
              }}</template
              ><template slot="selectedLabel">{{
                dataLang["select_selected"]
              }}</template>
              <template slot="deselectLabel">{{
                dataLang["select_unselect"]
              }}</template>
            </BaseSelect>
          </div>
        </div>

        <div class="tw-grid tw-grid-cols-[45%_auto] tw-items-center tw-mb-[6px]">
          <div>
            {{ dataLang["tariff_register_text_98"] }}
            <span class="tw-text-lightText">
              {{ dataLang["tariff_register_text_107"] }}
            </span>
          </div>
          <div ref="tariff_for_car__koeff_custom">
            <BaseInputNew
              inputClass="tw-app-input-type-3"
              placeholder=""
              class="wp-100 p-0"
              input-name="tariff_for_car__koeff_custom"
              @input="updateValue"
              :horizontalTitle="false"
              :value="dataForModal.tariff_for_car__koeff_custom"
              :additionalParams="{}"
              name-sign=""
              maxLength="5"
            />
          </div>
        </div>

        <div class="tw-grid tw-grid-cols-[45%_auto] tw-items-center tw-mb-[6px]">
          <div>
            {{ dataLang["tariff_register_text_114"] }}
          </div>
          <div ref="tariff_for_car__commission_place">
            <BaseSelect
              class="multiselect-type-3"
              placeholder="10"
              style="width: 100%"
              selectLabel=""
              deselectLabel=""
              :maxHeight="100"
              @input="
                (data) =>
                  updateValue({
                    name: 'tariff_for_car__commission_place',
                    value: data.value,
                  })
              "
              v-model="selectsFromModal.tariff_for_car__commission_place"
              :options="selectsData.tariff_for_car__commission_place"
              label="label"
            >
              <template slot="noOptions">{{
                dataLang["select_empty"]
              }}</template>
              <template slot="noResult">{{
                dataLang["select_search_empty"]
              }}</template
              ><template slot="selectedLabel">{{
                dataLang["select_selected"]
              }}</template>
              <template slot="deselectLabel">{{
                dataLang["select_unselect"]
              }}</template>
            </BaseSelect>
          </div>
        </div>

        <div class="tw-my-[15px]">
          <span class="tw-font-[600]">
            {{ dataLang["tariff_register_text_99"] }}
          </span>
          <span class="tw-text-lightText">
            {{ dataLang["tariff_register_text_111"] }}
          </span>
        </div>

        <div class="tw-grid tw-grid-cols-[45%_auto] tw-items-center tw-mb-[6px]">
          <div>
            {{ dataLang["tariff_register_text_100"] }}
            {{ dataLang["tariff_register_text_108"] }}
          </div>
          <div class="tw-flex tw-gap-[10px] tw-items-center">
            <BaseSelect
              class="multiselect-type-3"
              placeholder=""
              selectLabel=""
              deselectLabel=""
              openDirection="top"
              @input="
                (data) =>
                  updateValue({
                    name: 'tariff_for_car__commission_nodriver_day_custom',
                    value: data.value,
                  })
              "
              v-model="
                selectsFromModal.tariff_for_car__commission_nodriver_day_custom
              "
              :options="selectsData.comission"
              label="value"
            >
              <template slot="noOptions">{{
                dataLang["select_empty"]
              }}</template>
              <template slot="noResult">{{
                dataLang["select_search_empty"]
              }}</template
              ><template slot="selectedLabel">{{
                dataLang["select_selected"]
              }}</template>
              <template slot="deselectLabel">{{
                dataLang["select_unselect"]
              }}</template>
            </BaseSelect>
            <div class="tw-text-nowrap">
              {{ dataLang["tariff_register_text_105"] }}:
              <span class="tw-text-success">
                {{ dataForModal.tariff_for_car__commission_nodriver_day_top }}%
              </span>
            </div>
          </div>
        </div>

        <div class="tw-grid tw-grid-cols-[45%_auto] tw-items-center tw-mb-[6px]">
          <div>
            {{ dataLang["tariff_register_text_101"] }}
            {{ dataLang["tariff_register_text_109"] }}
          </div>
          <div class="tw-flex tw-gap-[10px] tw-items-center">
            <BaseSelect
              class="multiselect-type-3"
              placeholder=""
              selectLabel=""
              deselectLabel=""
              openDirection="top"
              @input="
                (data) =>
                  updateValue({
                    name: 'tariff_for_car__commission_nodriver_subs_custom',
                    value: data.value,
                  })
              "
              v-model="
                selectsFromModal.tariff_for_car__commission_nodriver_subs_custom
              "
              :options="selectsData.comission"
              label="value"
            >
              <template slot="noOptions">{{
                dataLang["select_empty"]
              }}</template>
              <template slot="noResult">{{
                dataLang["select_search_empty"]
              }}</template
              ><template slot="selectedLabel">{{
                dataLang["select_selected"]
              }}</template>
              <template slot="deselectLabel">{{
                dataLang["select_unselect"]
              }}</template>
            </BaseSelect>
            <div class="tw-text-nowrap">
              {{ dataLang["tariff_register_text_105"] }}:
              <span class="tw-text-success">
                {{ dataForModal.tariff_for_car__commission_nodriver_subs_top }}%
              </span>
            </div>
          </div>
        </div>

        <div class="tw-grid tw-grid-cols-[45%_auto] tw-items-center tw-mb-[6px]">
          <div>
            {{ dataLang["tariff_register_text_102"] }}
            {{ dataLang["tariff_register_text_110"] }}
          </div>
          <div class="tw-flex tw-gap-[10px] tw-items-center">
            <BaseSelect
              class="multiselect-type-3"
              placeholder=""
              selectLabel=""
              deselectLabel=""
              openDirection="top"
              @input="
                (data) =>
                  updateValue({
                    name: 'tariff_for_car__commission_nodriver_buyout_custom',
                    value: data.value,
                  })
              "
              v-model="
                selectsFromModal.tariff_for_car__commission_nodriver_buyout_custom
              "
              :options="selectsData.comission"
              label="value"
            >
              <template slot="noOptions">{{
                dataLang["select_empty"]
              }}</template>
              <template slot="noResult">{{
                dataLang["select_search_empty"]
              }}</template
              ><template slot="selectedLabel">{{
                dataLang["select_selected"]
              }}</template>
              <template slot="deselectLabel">{{
                dataLang["select_unselect"]
              }}</template>
            </BaseSelect>
            <div class="tw-text-nowrap">
              {{ dataLang["tariff_register_text_105"] }}:
              <span class="tw-text-success">
                {{
                  dataForModal.tariff_for_car__commission_nodriver_buyout_top
                }}%
              </span>
            </div>
          </div>
        </div>

        <div class="tw-grid tw-grid-cols-[45%_auto] tw-items-center tw-mb-[6px]">
          <div>
            {{ dataLang["tariff_register_text_103"] }}
          </div>
          <div class="tw-flex tw-gap-[10px] tw-items-center">
            <BaseSelect
              class="multiselect-type-3"
              placeholder=""
              selectLabel=""
              deselectLabel=""
              openDirection="top"
              @input="
                (data) =>
                  updateValue({
                    name: 'tariff_for_car__commission_driver_custom',
                    value: data.value,
                  })
              "
              v-model="
                selectsFromModal.tariff_for_car__commission_driver_custom
              "
              :options="selectsData.comission"
              label="value"
            >
              <template slot="noOptions">{{
                dataLang["select_empty"]
              }}</template>
              <template slot="noResult">{{
                dataLang["select_search_empty"]
              }}</template
              ><template slot="selectedLabel">{{
                dataLang["select_selected"]
              }}</template>
              <template slot="deselectLabel">{{
                dataLang["select_unselect"]
              }}</template>
            </BaseSelect>
            <div class="tw-text-nowrap">
              {{ dataLang["tariff_register_text_105"] }}:
              <span class="tw-text-success">
                {{ dataForModal.tariff_for_car__commission_driver_top }}%
              </span>
            </div>
          </div>
        </div>

        <div class="tw-app-modal__footer">
          <button
            @click="$modal.hide('EditsTariffModal')"
            class="tw-app-btn-muted tw-app-btn-muted-lg"
          >
            {{ dataLang["orders_model_edit__btn_text5"] }}
          </button>
          <button
            @click="sendData"
            class="tw-app-btn-primary tw-app-btn-primary-lg"
          >
            {{ dataLang["city_delivery_register_text_35"] }}
          </button>
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import GeneralService from "@/api/GeneralService.js";
import { VeTable } from "vue-easytable";
import EventBus from "@/event-bus.js";

export default {
  components: {
    VeTable,
  },
  props: {},
  data() {
    return {
      dataForModal: {},
      localLoading: true,
      updatedValues: {},
      selectsData: {
        grkoef: [],
        comission: [],
        tariff_for_car__commission_place: [],
      },
      selectsFromModal: {
        grkoef: [],
        tariff_for_car__commission_nodriver_day_custom: [],
        tariff_for_car__commission_nodriver_subs_custom: [],
        tariff_for_car__commission_nodriver_buyout_custom: [],
        tariff_for_car__commission_driver_custom: [],
        tariff_for_car__commission_place: [],
      },
      currentOpened: null,
      calcPrice: 0,
    };
  },
  methods: {
    loadData(params) {
      this.currentOpened = params.params.id;
      this.localLoading = true;
      Promise.all([
        GeneralService.get(`/tariffs_groups_car`)
          .then((data) => {
            this.selectsData.grkoef = data.data.rows;
          })
          .catch((e) => {
            this.$toast.error(e.response.data.message, { duration: 5000 });
          }),
      ]).then(() => {
        this.localLoading = false;
        GeneralService.get(`/tariffs_car/${params.params.id}`)
          .then((data) => {
            this.dataForModal = data.data.rows[0];
            this.selectsFromModal.tariff_for_car__commission_nodriver_day_custom =
              [
                {
                  value:
                    data.data.rows[0].tariff_for_car__commission_nodriver_day_custom.split(
                      "."
                    )[0],
                },
              ];
            this.selectsFromModal.tariff_for_car__commission_nodriver_subs_custom =
              [
                {
                  value:
                    data.data.rows[0].tariff_for_car__commission_nodriver_subs_custom.split(
                      "."
                    )[0],
                },
              ];
            this.selectsFromModal.tariff_for_car__commission_nodriver_buyout_custom =
              [
                {
                  value:
                    data.data.rows[0].tariff_for_car__commission_nodriver_buyout_custom.split(
                      "."
                    )[0],
                },
              ];
            this.selectsFromModal.tariff_for_car__commission_driver_custom = [
              {
                value:
                  data.data.rows[0].tariff_for_car__commission_driver_custom.split(
                    "."
                  )[0],
              },
            ];

            this.selectsFromModal.grkoef = this.selectsData.grkoef.find(
              (x) =>
                x.tariff_groups_for_car__id ==
                this.dataForModal.tariff_groups_for_car__id
            );

            this.selectsFromModal.tariff_for_car__commission_place.push(
              this.selectsData.tariff_for_car__commission_place.find(
                (x) =>
                  x.value ==
                  this.dataForModal.tariff_for_car__commission_place.split(
                    "."
                  )[0]
              )
            );

            this.calcPrice = this.dataForModal.tariff_for_car__cost_with_koeff;

            // tariff_for_car__cost_with_koeff
            // this.dataForModal.tariff_for_car__koeff_price *

            if (this.dataForModal.tariff_for_car__pledge) {
              this.dataForModal.tariff_for_car__pledge =
                this.dataForModal.tariff_for_car__pledge.split(".")[0];
            }

            this.dataForModal.tariff_for_car__koeff_price = String(
              this.dataForModal.tariff_for_car__koeff_price
            ).replace(".", ",");
            if (
              !this.dataForModal.tariff_for_car__koeff_custom.included(".") &&
              this.dataForModal.tariff_for_car__koeff_custom
            ) {
              this.dataForModal.tariff_for_car__koeff_custom = Number(
                this.dataForModal.tariff_for_car__koeff_custom
              ).toFixed(1);
            }
            this.dataForModal.tariff_for_car__koeff_custom = String(
              this.dataForModal.tariff_for_car__koeff_custom
            ).replace(".", ",");

            this.localLoading = false;
          })
          .catch((e) => {
            this.$toast.error(e.response.data.message, { duration: 5000 });
          });
      });

      //   /tariffs_groups_car
    },
    beforeClose(event) {
      this.currentOpened = null;
      this.dataForModal = {};
      this.updatedValues = {};
      this.selectsFromModal = {
        grkoef: [],
        tariff_for_car__commission_nodriver_day_custom: [],
        tariff_for_car__commission_nodriver_subs_custom: [],
        tariff_for_car__commission_nodriver_buyout_custom: [],
        tariff_for_car__commission_driver_custom: [],
        tariff_for_car__commission_place: [],
      };
    },
    updateValue(data) {
      this.updatedValues[data.name] = data.value;
      if (data.name == "tariff_for_car__koeff_price") {
        if (String(this.updatedValues[data.name]).includes(",")) {
          let stringNew = data.value.replace(",", ".");
          this.updatedValues[data.name] = stringNew;
        }

        this.calcPrice =
          this.dataForModal.vehicles__cost *
          Number(data.value.replace(",", "."));
      }

      if (data.name == "tariff_for_car__koeff_custom") {
        if (String(this.updatedValues[data.name]).includes(",")) {
          let stringNew = data.value.replace(",", ".");
          this.updatedValues[data.name] = stringNew;
        }
      }

      this.$refs[data.name].classList.remove("input-error");
    },
    sendData() {
      if (Object.keys(this.updatedValues).length) {
        this.localLoading = true;
        GeneralService.edit(`/tariffs_car/${this.currentOpened}`, {
          ...this.updatedValues,
        })
          .then((data) => {
            this.$toast.success(data.data.message);
            this.$modal.hide("EditsTariffModal");
            EventBus.$emit("updateContentDataTariff");
          })
          .catch((e) => {
            Object.keys(e.response.data.errors).forEach((elem, index) => {
              if (this.$refs[elem]) {
                this.$refs[elem].classList.add("input-error");
              }
            });
            this.localLoading = false;
            this.$toast.error(e.response.data.message, { duration: 5000 });
          });
      } else {
        this.$modal.hide("EditsTariffModal");
      }
    },
  },
  mounted() {
    for (let index = 20; index <= 30; index++) {
      this.selectsData.comission.push({ value: index });
    }
    for (let index = 10; index <= 50; index++) {
      this.selectsData.tariff_for_car__commission_place.push({
        label: index,
        value: index,
      });
    }
  },
  created() {},
  beforeDestroy() {},

  computed: {
    ...mapState("translationModule", ["dataLang"]),
  },
};
</script>
